import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import CustomiseSidebar from "./CustomiseSidebar";

const CustomiseWheat = () => {
    const location = useLocation();
    const [cartItem, setCartItem] = useState(location.state?.cartItems || []);

    // Force component to recognize route changes
    useEffect(() => {
        // This will trigger when location changes
    }, [location]);

    return (
        <>
            <div className="customise-wheat">
                <div className="container">
                    <div className="row">
                        <CustomiseSidebar key={location.pathname} cartItem={location.search === 'type=edit' ? cartItem : []} locationData={location} />
                    </div>
                </div>
            </div>
        </>
    );
};

export default CustomiseWheat;
